<template>
  <div>
    <jd-table
      :tableInfo="tableInfo"
      :tableData="newTableData"
      :selection="selection"
      :selectable="selectableFn"
      rowKey="id"
      ref="multipleTable"
      :loading="loading"
      :pageInfo="{
        pageNum: pageInfo.current,
        pageSize: pageInfo.size,
        total: totalNum,
        noShow: noShow,
      }"
      @handlePage="handlePageChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <template #sortSlot="{ row, rowIndex }">
        {{ rowIndex + 1 }}
      </template>
      <template #urlSlot="{ row }">
        <div class="img-box">
          <el-image
            class="url-img"
            :src="row.shareUrl || row.imageUrl"
            :preview-src-list="[row.shareUrl || row.imageUrl]"
          >
          </el-image>
        </div>
      </template>
      <template #shareContentSourceSlot="{ row }">
        {{ row.shareContentSource }}
      </template>
      <template #operationSlot="{ row, rowIndex }">
        <jd-button type="blueText" @click="delContentFn(rowIndex, row)"
          >删除</jd-button
        >
        <jd-button
          type="blueText"
          @click="editContentFn(row, rowIndex)"
          v-if="isShowEditBtn"
          >编辑</jd-button
        >
        <jd-button
          type="blueText"
          @click="selectTemFn(row)"
          v-if="isShowSelectTem"
          >选择模板</jd-button
        >
      </template>
    </jd-table>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    tableInfo: {
      type: Array,
      // required: true,
      default: () => [],
    },
    tableData: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 是否显示编辑按钮
    isShowEditBtn: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Boolean,
      default: false,
    },
    hasSelect: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // 是否显示选择模板按钮
    isShowSelectTem: {
      type: Boolean,
      default: false,
    },
    // 删除操作是否请求接口
    delByApi: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    noShow: {
      type: Boolean,
      default: true,
    },
    pageInfo: {
      type: Object,
      default: () => ({
        current: 1,
        size: 10,
      }),
    },
  },
  data() {
    return {
      totalNum: 0,
    };
  },
  computed: {
    newTableData: {
      get() {
        return this.tableData;
      },
      set(val) {
        this.$emit("update:tableData", val);
      },
    },
    selectableFn() {
      return (row) => {
        return !this.isEdit;
      };
    },
  },
  watch: {},
  mounted() {},
  methods: {
    handlePageChange({pageNum, pageSize}) {
      this.pageInfo.current = pageNum;
      this.pageInfo.size = pageSize;
      this.$emit("updatePageInfo", this.pageInfo);
    },
    handleSelectionChange(val) {
      this.$emit("selectItemChange", val);
    },
    editContentFn(row, index) {
      this.$emit("edit", row, index);
    },
    delContentFn(index, row) {
      if (this.delByApi) {
        this.$emit("delFn", row);
      } else {
        this.newTableData.splice(index, 1);
      }
    },
    selectTemFn(row) {
      this.$emit("selectTem", row);
    },
  },
};
</script>
<style lang="scss" scoped>
.img-box {
  padding: 10px 0 4px;
  .url-img {
    width: 70px;
    // height: 89px;
  }
}
</style>
